import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import PNXLabel from "./PNXLabel";


interface Props {
  controlProps: controls.RulesetDisplay;
};

const PhoenixRulesetDisplay = ({
  controlProps,
} : Props) => {

  const rule = controlProps.rule;

  if (!rule) return null;

  const isHexadecimal = (str) => {
    if (!str)
        return false;

    var rx = /^[0-9A-Fa-f]+$/g;
    return rx.test(str);
  }

  let color = "";
  let backgroundColor = "";

  if (rule.color && rule.color.length === 6 && isHexadecimal(rule.color)) {
    color = `#${rule.color}`;
  }
  if (rule.backgroundColor && rule.backgroundColor.length === 6 && isHexadecimal(rule.backgroundColor)) {
    backgroundColor = `#${rule.backgroundColor}`;
  }

  return (
    <div>
      <PNXLabel>{controlProps.label}</PNXLabel>
      <div>
        <div>{rule.name ?? ""}</div>
        <div className="ruleset-tag" style={{color: color, backgroundColor: backgroundColor}}>{rule.level}</div>
      </div>
    </div>
  );
};

export default PhoenixRulesetDisplay;